<template>
    <span class="d-flex w-100 flex-column">
        <span class="w-100 text-center p-0 m-0">
            <b-button variant="outline" style="padding: 0" v-b-toggle="toggleId" >
                <b-icon class="toggleUpDown" :class="{'rotate': opened}" icon="chevron-down" variant="secondary" scale="1" />
            </b-button>
        </span>
        <slot name="secondary">
        </slot>
    </span>
</template>

<script>
import EventBus from "@/bus";

export default {
    name: "AnimalToggleRowCell",
    props: {
        value: {}
    },
    data() {
        return {
            opened: false
        }
    },
    computed: {
        toggleId() {
            return 'collapse-row-' + this.value
        }
    },
    mounted() {
        EventBus.$off('on-collapse-changed-' + this.toggleId);
        EventBus.$on('on-collapse-changed-' + this.toggleId, (collapseId, isJustShown) => {
            if (this.toggleId === collapseId) {
                if (isJustShown) {
                    EventBus.$emit('animal-toggle-row-' + this.value, {'animalId': this.value})
                }
                this.opened = isJustShown;
            }
        })
    }

}
</script>

<style scoped>
.toggleUpDown {
    transition: transform .3s ease-in-out !important;
}

.toggleUpDown.rotate {
    transform: rotate(180deg);
}
</style>